export default __webpack_public_path__ + "static/media/Human3.7a699983.png";